import {AlertService} from '../../shared/services/alert.service';
import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { Assessment } from "../../shared/models/assessment";
import { AssessmentService } from "../../shared/services/assessment.service";

@Component({
  selector: 'app-assessment-new',
  templateUrl: './assessment-new.component.html',
  styleUrls: ['./assessment-new.component.css']
})
export class AssessmentNewComponent implements OnInit {

  private _assessment:Assessment;

  constructor(
    private _assessmentService:AssessmentService
    ,private router: Router
    ,private alertService: AlertService
    ,private route: ActivatedRoute
  ) {
    this._assessment = new Assessment();
    this._assessment.name = "Untitled";
  }

  ngOnInit() {
  }

  get assessment() {
    return this._assessment;
  }
  set assessment(v:Assessment) {
    this._assessment = v;
  }

  private validateAssessment(assessment:Assessment) {
    let errors = [];
    if (typeof assessment.uid != 'string'
      || assessment.uid.trim() == "") {
        errors.push("Unique id is missing");
    }
    if (typeof assessment.name != 'string'
      || assessment.name.trim() == "") {
      errors.push("Name is missing");
    }
    if (typeof assessment.description != 'string'
      || assessment.description.trim() == "") {
      errors.push("Description is missing");
    }
    return errors;
  }

  save() {
    let errors = this.validateAssessment(this._assessment);
    if (errors.length) {
      this.alertService.error("Please correct the following errors: " + errors.join(".\n"), 3000);
      return;
    }

		console.log(this._assessment);
	
		this._assessmentService.createAssessment(this._assessment)
		.then(() => {
      this.alertService.success("Assessment Saved!");
      // TODO: stephen figure out how to use the angular2 version of this instead of the raw setTimeout
				setTimeout(() => {
          this.router.navigate(["../", this._assessment.uid, "edit"], {relativeTo: this.route, replaceUrl: true});
				}, 1500);
      })
      .catch((error) => {
        if (error && error.code) {
          if (error.code === 'DUP_ENTRY') {
            this.alertService.error("An assessment already exists with that unique id.  Please try a different one");
            return;
          }
        }

        this.alertService.error("Error occurred in saving your assessment. Please try again.");
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/admin/assessment-new/assessment-new.component.ts